/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Inject, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from '../../core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import _ from 'lodash';
import { MyCustomPaginatorIntl } from '../../core/services/paginator_service/my-paginator.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LineItemService } from '../../core/services/lineitem/lineitem.service';
import { AvailabilityTypes, BundlePricingLevelTypes } from './product-bundle-item-picker.interface';
import { ProductService } from 'app/core/services/products/products.service';
import { ProductBundleEditFormComponent } from '../product-bundle-edit-form/product-bundle-edit-form.component';
import { BundleItemPickerService } from './product-bundle-item-picker.service';

@Component({
  selector: 'product-bundle-item-picker',
  templateUrl: './product-bundle-item-picker.component.html',
  styleUrls: ['./product-bundle-item-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy?.OnPush,
  providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }]
})
export class ProductBundleItemPickerComponent implements OnInit, OnChanges, OnDestroy {

  @Input() options: any;
  @Output() optionSelected? = new EventEmitter<any>();
  @ViewChild(ProductBundleEditFormComponent) ProductBundleEditFormComponent!: ProductBundleEditFormComponent;

  showFinanceCard: boolean = false;
  filterVisible: boolean = false;
  showPrice: boolean = false;
  isInitialVisibilityChange: boolean = true;
  isPricelistPresent: boolean = false;
  proposalOptions: any[] = [];
  companyConfig: any;
  companyPolicy: any;
  companyCurrency: any;
  bundleParams: any;
  searchedValue: string = '';
  searchKey: string = '';
  viewMode: string = '';
  lineItemApiUrls: any;
  quotesTax: any[] = [];
  selectedProducts: any[] = [];
  displayedColumns: any[] = [];
  getCategoryAsObject: boolean = false;
  fetchingBundles: boolean = false;
  AddingBundles: boolean = false;
  products: any[] = [];
  originalDataProducts: any[] = [];
  categories: any[] = [];
  filterLocationUid: string;
  selectedProductBundle: any;
  currentSelectedProductBundle: any;
  selectedBundle: any;
  restrictedColumns = ['PRICE', 'PURCHASE_PRICE', 'MARKUP'];
  availabilityTypes: any[] = AvailabilityTypes;
  bundlePricingLevelTypes: any[] = BundlePricingLevelTypes;
  copyOptions: any;
  pagination: any = {
    totalRecords: 0,
    pageIndex: 1,
    pageSize: 5
  };

  private productParamObj: any = {
    'count': 5,
    'filter.keyword': '',
    'filter.product_type': '',
    'filter.product_category': '',
    'filter.pricing_level': '',
    'page': 1
  };
  private categoryParamObj: any = {
    'count': 200,
    'page': 1
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private localisationService: LocalisationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _dataCollectorService: DataCollectorService,
    private lineItemService: LineItemService,
    public utilityService: UtilityService,
    public productService: ProductService,
    public bundleItemPickerService: BundleItemPickerService,
    public dialogRef: MatDialogRef<ProductBundleItemPickerComponent>,
  ) {
  }

  ngOnInit(): void {

    this.localisationService.setDefaultLanguage();
    this.companyCurrency = this.utilityService.companyCurrency;
    this.companyConfig = this.utilityService.companyConfig;
    this.showPrice = this.utilityService.hasPermission('product.show_selling_price') ?? false;
    this.lineItemApiUrls = this.lineItemService.lineItemAPIUrls;
    this.options = this.data?.data?.options ?? this.options;
    if (this.options.remoteData?.params?.pricelist) {
      this.isPricelistPresent = true;
    }

    this.viewMode = 'SingleItem';
    this.updateDisplayedColumns();
    this.getLineItemData();
    if (this.options?.getCategoryAsObject) {
      this.getCategoryAsObject = this.options?.getCategoryAsObject ?? false;
    }
  }

  updateDisplayedColumns(): void {
    if (this.options?.columns) {
      this.displayedColumns = this.displayedColumns.concat(this.options.columns?.map(column => column.type));
      if (this.showPrice === false) {
        this.displayedColumns = this.displayedColumns.filter(value => this.restrictedColumns.includes(value) === false);
      } else if (this.showPrice && (this.companyConfig?.product?.enable_markup === false)) {
        this.displayedColumns = this.displayedColumns.filter(value => ['MARKUP'].includes(value) === false);
      }
    }
  }

  getLineItemData(): void {
    if (this.options?.data?.length > 0) {
      this.originalDataProducts = this.options.data;
      this.updateProducts(this.options.data);
      this.getProductCategoryData();
      if (this.products?.length > 0) {
        this.updateProductBundleSelection(this.currentSelectedProductBundle?.product_uid ? this.currentSelectedProductBundle : this.products[0]);
      }
    }
    else{
      const productUrl: string = this.options.remoteData?.dataUrl || this.lineItemApiUrls.productUrl;
      if (this.options.remoteData?.dataUrl && this.options.remoteData?.params) {
        this.productParamObj = { ...this.productParamObj, ...this.options.remoteData.params };
      }
      this.productParamObj.page = this.pagination.pageIndex;
      this.fetchingBundles = true;
      this._dataCollectorService.getData(productUrl, this.productParamObj).subscribe((response: any) => {
        this.fetchingBundles = false;
        this.originalDataProducts = response.data;
        this.pagination.totalRecords = response.total_records;
        this.updateProducts(response?.data);
        this.getProductCategoryData();
        if (this.products?.length > 0) {
          this.updateProductBundleSelection(this.currentSelectedProductBundle?.product_uid ? this.currentSelectedProductBundle : this.products[0]);
        }
        this._changeDetectorRef.markForCheck();
      }, (_error: any) => {
        this.fetchingBundles = false;
      });
    }
  }

  getProductCategoryData(): void {
    if (this.options?.filters?.category?.enabled && this.categories?.length === 0) {
      this._dataCollectorService.getData(this.lineItemApiUrls.productCategoryUrl, this.categoryParamObj).subscribe((categories: any) => {
        this.categories = categories.data;
      }, (_error: any) => {
      });
    }
  }

  updateProducts(products: any): void {
    this.products = _.cloneDeep(products);
  }

  onSelectProductBundle(event: any, productBundle: any): void {
    if (event?.target?.checked) {
      this.updateProductBundleSelection(productBundle);
    }
  }

  updateProductBundleSelection(productBundle: any): void {
    if (productBundle?.product_uid) {
      this.currentSelectedProductBundle = productBundle;
      if(this.options?.data?.length > 0){
        this.handleProductBundleDetails(this.currentSelectedProductBundle,false);
      }
      else{
        this.getProductBundleDetails(productBundle?.product_uid);
      }
    }
  }

  getProductBundleDetails(productId): void {
    let param = {};
    if(!this.utilityService.isEmptyOrUndefined(this.productParamObj?.pricelist)){
      param = {pricelist:this.productParamObj?.pricelist}
    }
    const url: string = this.productService.getProductDetails(productId);
    this._dataCollectorService.getData(url,param).subscribe((response: any) => {
      this.handleProductBundleDetails(response.data);
    }, (_error: any) => {
    });
  }

  handleProductBundleDetails(productBundleData: any,populateData: boolean = true): void {
    const markupType = this.companyConfig?.product?.default_markup_type ?? 'FLAT';
    this.selectedProductBundle = productBundleData?.pricing_level === 'ROLLUP' ? 
                                 productBundleData :
                                 {...productBundleData,markup: productBundleData?.markup ?? {markup_type:markupType}};

    if (this.options?.type === 'NEW' && populateData) {
      this.selectedProductBundle.associated_products = _.map(
        this.selectedProductBundle.associated_products,
        item => ({
          product: item.product,
          quantity: item.quantity,
          product_uid: item.product?.product_uid,
          prefix: item.product?.prefix,
          product_id: item.product?.product_id,
          location_availability: item.product?.location_availability,
          price: item.product?.price,
          purchase_price: item.product?.purchase_price,
          product_type: item.product?.product_type,
          product_description: item.product?.product_description,
          tax: item.product?.tax,
          markup: item.product?.markup ?? {markup_type:markupType},
        })
      );
    }

    this.copyOptions = _.cloneDeep(this.options);
    if (this.selectedProductBundle?.pricing_level && this.options) {
      const pricingLevel = this.selectedProductBundle.pricing_level;

      if (this.showPrice && this.companyConfig?.product?.enable_markup === false) {
        this.copyOptions.columns = this.options.columns.filter(
          value => value?.type !== 'MARKUP'
        );
      }

      if (pricingLevel === 'ROLLUP' && this.options.fieldOptions) {
        this.copyOptions.fieldOptions = this.options.fieldOptions.filter(
          value =>
            !['markup', 'tax_preference', 'discount'].includes(value?.fieldName)
        );
      } else if (pricingLevel === 'BUNDLE' && this.options.columns) {
        this.copyOptions.columns = this.options.columns.filter(
          value => !['PURCHASE_PRICE', 'MARKUP'].includes(value?.type)
        );
      }
    }


    this._changeDetectorRef.detectChanges();
  }
  onCategoryChange(event: any): void {
    if (event) {
      const categoryId: any = event.value;
      if (this.options?.data) {
        let filteredCategory: any[] = [];
        if (categoryId) {
          this.originalDataProducts.filter((value: any) => {
            if (((value.product_category?.category_uid === categoryId) || (value?.product_ref_id?.product_category?.category_uid === categoryId))) {
              filteredCategory.push(value);
            }
          });
        } else {
          filteredCategory = this.originalDataProducts;
        }
        this.updateProducts(filteredCategory);
      }
      else{
        this.pagination.pageIndex = 1;
        this.productParamObj['filter.product_category'] = categoryId;
        this.getProductData();
      }
    }
  }

  onAvailabilityChange(event: any): void {
    if (event) {
      const type: any = event.value;
      if (this.options?.data) {
        let filteredProducts: any[] = [];
        if (type !== 'ALL') {
          filteredProducts = this.originalDataProducts.filter(value => value.is_available === type) ?? [];
        } else {
          filteredProducts = this.originalDataProducts;
        }
        this.updateProducts(filteredProducts);
      }
      else{
        this.pagination.pageIndex = 1;

        if (type === 'ALL') {
          delete this.productParamObj['filter.is_available'];
        } else {
          this.productParamObj['filter.is_available'] = type;
        }
        this.getProductData();
      }
    }
  }

  onBundlePricingLevelChange(event: any): void {
    if (event) {
      const type: any = event.value;
      if (this.options?.data) {
        let filteredProducts: any[] = [];
        if (type !== 'ALL') {
          filteredProducts = this.originalDataProducts.filter(value => value.pricing_level === type) ?? [];
        } else {
          filteredProducts = this.originalDataProducts;
        }
        this.updateProducts(filteredProducts);
      }
      else{
        this.pagination.pageIndex = 1;

        if (type === 'ALL') {
          delete this.productParamObj['filter.pricing_level'];
        } else {
          this.productParamObj['filter.pricing_level'] = type;
        }
        this.getProductData();
      }
    }
  }

  triggerSearch(searchKey: string): void {
    this.searchedValue = searchKey;

    if (this.options?.data && this.options?.data?.length > 0) {
      let filteredCategory: any[] = [];
      if (searchKey) {
        this.originalDataProducts.filter((value: any) => {
          if (value.product_name.includes(searchKey)) {
            filteredCategory.push(value);
          }
        });
      } else {
        filteredCategory = this.originalDataProducts;
      }
      this.updateProducts(filteredCategory);
    }
    else{
      this.pagination.pageIndex = 1;
      this.productParamObj['filter.keyword'] = searchKey;
      this.getProductData();
    }

  }


  changePickerFilterVisibility(): void {
    this.filterVisible = !this.filterVisible;
    if (this.isInitialVisibilityChange && this.filterVisible) {
      this.isInitialVisibilityChange = false;
    } else if (this.filterVisible) {
    }
  }


  addItems(_event: any): void {
    if (this.viewMode === 'SingleItem') {
      this.addLineItems();
    }
  }

  addLineItems(): void {
    if (this.ProductBundleEditFormComponent.validateSelectedItemsControls()) {
      const bundlePayload = this.ProductBundleEditFormComponent.constructBundleItemPayload();
      this.bundleItemPickerService.onAddBundleItemClicked.next([bundlePayload]);
    }
  }

  onPageItemEvent(event: any): void {
    this.pagination.pageIndex = event.pageIndex + 1;
    this.getLineItemData();
  }

  getProductData(): void {
    this.fetchingBundles = true;
    this.productParamObj.page = this.pagination.pageIndex;
    this._dataCollectorService.getData(this.lineItemApiUrls.productUrl, this.productParamObj).subscribe((response: any) => {
      this.fetchingBundles = false;
      this.updateProducts(response.data);
      this.originalDataProducts = response.data;
      this.pagination.totalRecords = response.total_records;
      if (this.products?.length > 0) {
        this.updateProductBundleSelection(this.products[0]);
      }
    }, (_error: any) => {
      this.fetchingBundles = false;
    });
  }

  showDescriptionRichText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  ngOnDestroy(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('options' in changes) {
      this.options = changes.options.currentValue;
      this.copyOptions = _.cloneDeep(this.options);
    }
  }

}
